
import type { ShipType } from '@fleetduel/shared'
import { SHIP_DEFS } from '@fleetduel/shared'
import { SHIP_ASSETS } from '../../assets/index.js'

interface ShipPieceProps {
  shipType: ShipType
  isPlaced: boolean
  isSelected: boolean
  onClick: () => void
  /** Smaller thumbnails/padding so all three pieces fit one row on phones */
  compact?: boolean
}

const shipLabels: Record<ShipType, string> = {
  destroyer: 'Destroyer',
  patrol_boat: 'Patrol Boat',
  ghost_sub: 'Ghost Sub',
}

export function ShipPiece({ shipType, isPlaced, isSelected, onClick, compact = false }: ShipPieceProps) {
  const def = SHIP_DEFS[shipType]
  // Scale down from 64px height for thumbnails
  const thumbHeight = compact ? 32 : 48
  const thumbWidth = (def.size * 64) * (thumbHeight / 64)

  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: compact ? 2 : 4,
        padding: compact ? '6px 8px' : '8px 12px',
        // Placed ships stay clickable so their placement can be edited
        border: isSelected ? '2px solid #F4B942' : '2px solid transparent',
        borderRadius: 8,
        backgroundColor: isPlaced ? '#1a2a3a' : '#263238',
        color: isPlaced ? '#8DA9C4' : '#fff',
        cursor: 'pointer',
        // Dimmed but not disabled — signals "placed, tap to edit"
        opacity: isPlaced ? 0.6 : 1,
        filter: isPlaced ? 'grayscale(0.4)' : 'none',
        minWidth: compact ? undefined : 80,
      }}
    >
      {/* Ship SVG thumbnail */}
      <img
        src={SHIP_ASSETS[shipType]}
        alt={shipLabels[shipType]}
        style={{
          width: thumbWidth,
          height: thumbHeight,
        }}
        draggable={false}
      />
      <div style={{ fontSize: 11, fontWeight: 600 }}>{shipLabels[shipType]}</div>
      <div style={{ fontSize: 10, color: isPlaced ? '#F4B942' : '#A6C6E1' }}>
        {isPlaced ? 'Placed · tap to edit' : (
          <>{def.size} cells{def.traits.length > 0 && ' | Stealth'}</>
        )}
      </div>
    </button>
  )
}
